import {getBulkActionSlice} from 'src/components/bulk-tool';

import type {
    BulkActionIdSelector,
    BulkActionShownSelector,
    BulkActionTaskSelector,
} from 'src/components/bulk-tool';

export const unsubscribeFromLcdCreditAnalysisSlice = getBulkActionSlice(
    'unsubscribeFromLcdCreditAnalysis',
);

export const unsubscribeFromLcdCreditAnalysisUuidSelector: BulkActionIdSelector = state =>
    state.bulkUpdateResult.unsubscribeFromLcdCreditAnalysisResult.uuid;

export const unsubscribeFromLcdCreditAnalysisShownSelector: BulkActionShownSelector = state =>
    state.bulkUpdateResult.unsubscribeFromLcdCreditAnalysisResult.shown;

export const unsubscribeFromLcdCreditAnalysisTaskSelector: BulkActionTaskSelector = state =>
    state.bulkUpdateResult.unsubscribeFromLcdCreditAnalysisResult.backgroundTask;


export const {
    setUuid,
    setShown,
    setBackgroundTask,
    clearResult,
} = unsubscribeFromLcdCreditAnalysisSlice.actions;
